import ZoomLogo from '@/assets/images/zoom-tcap.svg';

const ZoomIcon = ({ size = 25 }) => (
    <img src={ZoomLogo} alt="Zoom Logo" style={{ height: size, width: size }} />
);

export default ZoomIcon;
